import styled from "styled-components";

export const GraphContainer = styled.div`
  h3 {
    margin-top: 25px;
    margin-bottom: 10px;
  }
`;

export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const ChartContainer = styled.div`
  width: 100%;
  max-width: 900px;
`;

export const ChartImages = styled.div`
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    pointer-events: none;
    user-select: none;
  img {
    position: absolute;
    width: 50px;
    left: 50%;
    transform: translateX(-50%);
    user-select: none;
    pointer-events: none;
  }

  img:nth-child(1) {
    top: 0px;
  }

  img:nth-child(2) {
    bottom: 25px;
  }


  @media (max-width: 700px) {
    margin-top: 0;
    img {
      width: 40px;
    }
  }
  @media (max-width: 401px) {
    img {
      width: 30px;
    }
  }
`;

export const TooltipContainer = styled.div<{ color: string }>`
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  div {
    height: 15px;
    width: 15px;
    border-radius: 50px;
    background-color: ${(props) => props.color};
  }
`;

export const StatsNotFound = styled.div`
  text-align: center;
  margin: 30px 0;

  p {
    color: ${(props) => props.theme.fontColor}80;
    font-weight: bold;
  }
`;
